<template>
    <div>
  
        <v-select
          size="sm"
          placeholder="-- Pilih Modul --"
          :options="options"
          :reduce="modulType => modulType.value"
          label="text"
          v-model="modelValue"
        />
      
      
      
    </div>
  </template>
  
  <script>
  import _ from "lodash";
  import vSelect from "vue-select";
  
  export default {
    data() {
      return {
        options: [],
      };
    },
    
    components: {
      vSelect,
    },
  
    props: {
      value: {
        type: ""
      },
    },
    
    computed: {
      modelValue: {
        get: function () {
  
          if (this.value !== undefined) {
            return this.value;
          }
          
        },
        set: function (data) {
          this.$emit("value", null);
          if (data !== null) {
              this.$emit("value", data);
          }
        },
      },
    },
    methods: {
      getData() {

        const queryParams = {
          paramSystemName: "MODUL_TYPE"
        }

        this.$http
          .get("/mastering/systemParameterList/findAll", { params: queryParams })
          .then((response) => {
            let result = response.data.data.content;
              
            for (let i = 0; i < result.length; i++) {
              result[i].value = result[i].paramListValue;
              result[i].text = result[i].paramListDesc;
              delete result[i].key;
              delete result[i].label;
            }

            console.log('ambil modul')
            console.log(result)
  
            this.options = result;
          });
          
      },
    },
    
    mounted() {
      this.getData();
    },
  };
  </script>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  </style>
  